export default __webpack_public_path__ + "static/sc-congress-52ce808df63d7631164f20a6d1f2e232.webp";